import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

type VariantStyles = {
  backgroundColor: string;
  borderColor?: string;
  color: string;
};

const createVariantStyles = ({ backgroundColor, borderColor, color }: VariantStyles) => css`
  background-color: ${backgroundColor};
  color: ${color};
  border: 1px solid ${borderColor ?? 'transparent'};

  &:visited {
    background-color: ${backgroundColor};
    color: ${color};
    border-color: ${borderColor ?? 'transparent'};
  }

  &:hover:not([disabled]):not([aria-disabled='true']) {
    background-color: color-mix(
      in srgb,
      ${color} var(${themeVariables.tint.hover}),
      ${backgroundColor} calc(100% - var(${themeVariables.tint.hover}))
    );
  }

  &[disabled],
  &[aria-disabled='true'] {
    background-color: color-mix(
      in srgb,
      ${color} var(${themeVariables.tint.disabled}),
      ${backgroundColor} calc(100% - var(${themeVariables.tint.disabled}))
    );
    color: color-mix(
      in srgb,
      ${color},
      ${backgroundColor} calc(var(${themeVariables.tint.disabled}) * 1.5)
    );
  }
`;

export const root = css`
  align-items: center;
  appearance: none;
  border-radius: var(${themeVariables.borderRadius.full.mobile});
  box-shadow: 0 0 4px 0
    color-mix(in srgb, var(${themeVariables.colors.content.primary}) 10%, transparent);
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  line-height: 0;
  padding: var(${themeVariables.spacing.sm});
  text-decoration: none;

  &[disabled],
  &[aria-disabled='true'] {
    cursor: not-allowed;
  }
`;

// The IconButton has a single appearance, matching Button's secondary visual style.
export const appearance = css`
  ${createVariantStyles({
    backgroundColor: 'transparent',
    borderColor: `var(${themeVariables.colors.stroke.interactive})`,
    color: `var(${themeVariables.colors.content.interactive})`,
  })}
`;

export const compact = css`
  padding: var(${themeVariables.spacing.xs});
`;

export const icon = css`
  align-items: center;
  display: inline-flex;
  line-height: 0;

  & > svg {
    display: block;
  }
`;
